import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { PageSlotModule } from '@spartacus/storefront'
import { UserAccountModule } from '@spartacus/user'
import { UserAccountService } from '@spartacus/user/account/core'
import { EbLoginComponent } from './components/login/eb-login.component'
import { EbUpdateProfileFormModule } from './components/profile/eb-update-profile-form.module'
import { EbUserAdapter } from './services/connectors/eb-user-adapter'
import { EbUserAccountService } from './services/eb-user-account.service'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    PageSlotModule,
    I18nModule,
    UserAccountModule,
    EbUpdateProfileFormModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        LoginComponent: {
          component: EbLoginComponent
        }
      }
    } as CmsConfig),
    {
      provide: UserAccountService,
      useClass: EbUserAccountService
    },
    EbUserAdapter
  ],
  declarations: [EbLoginComponent],
  exports: [EbLoginComponent]
})
export class EbUserModule {}
